var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"white","elevation":"0"},on:{"click":_vm.logout}},[_c('v-icon',[_vm._v("mdi-logout")]),_vm._v("\r\n    Cerrar Sesión\r\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }